import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  Injector,
  Input,
  OnInit,
  Optional,
  QueryList,
  TemplateRef,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PrimeTemplate } from 'primeng/api';
import { MenuService } from '../../../core/services/menu.service';
import { BaseComponent } from '../base.component';

export const REMARK_WIDGET_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RemarkWidgetComponent),
  multi: true,
};

@Component({
  selector: 'sigv-remark-widget',
  templateUrl: './remark-widget.component.html',
  styleUrls: ['./remark-widget.component.scss'],
  providers: [REMARK_WIDGET_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemarkWidgetComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, ControlValueAccessor
{
  @Input() remarkRecords: any[] = [];
  @Input() readonly = false;
  @ContentChildren(PrimeTemplate) templates!: QueryList<PrimeTemplate>;
  remarkTemplate!: TemplateRef<any>;
  model = '';
  isMenuVisible = false;
  isShowRemarkRecords = true;
  isShowRemarkRecordDialog = false;
  onModelChange: Function = () => {};
  onModelTouched: Function = () => {};

  constructor(
    private injector: Injector,
    private cd: ChangeDetectorRef,
    @Optional() private menuService: MenuService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.menuService?.getSideMenuObservable().subscribe({
      next: (isOpen) => {
        this.isMenuVisible = isOpen;
      },
      error: (err) => this.logger.error(err),
    });
  }

  ngAfterViewInit(): void {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'remark':
          this.remarkTemplate = item.template;
          break;
        default:
          break;
      }
    });
    this.cd.detectChanges();
  }

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  toggleRemarkRecordDialog(): void {
    this.isShowRemarkRecordDialog = !this.isShowRemarkRecordDialog;
  }

  updateModel(event: any): void {
    this.onModelChange(event);
  }

  toggleRemarkRecord(): void {
    this.isShowRemarkRecords = !this.isShowRemarkRecords;
  }
}
